export enum ROUTE_PATH {
  ERROR403 = 'error403',
  ERROR404 = 'error404',
}
